import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../models/reduxState';
import { RequestDetails } from '../../presentationalComponents/RequestDetails/RequestDetails';
import { setDirtyRequest, resetRequestDetailsEditError } from '../../reduxUpdater/actions/requestDetailsActions';
import { customerAvailabilityConfirmedSelector, businessImpactConfirmedSelector } from '../../reduxUpdater/selectors/commonSelectors';
import { isUnifiedPremierSelector, isUnifiedEnterprisePremierSelector, isNonUnifiedPremierSelector, isPremierTenantEnabledSelector } from '../../reduxUpdater/selectors/globalStateSelectors';
import { errorListSelector, showErrorSelector } from '../../reduxUpdater/selectors/requestDetailsSelectors';
import { pristineRequestSelector } from '../../reduxUpdater/selectors/requestHistorySelectors';
import { requestSelector, notesSelector, severitySelector, isAttachmentsEnabledSelector, isRequestDetailsEditModeSelector } from '../../reduxUpdater/selectors/requestSelector';
import { getRequestDetailsStyles } from '../../styles/requestDetailsStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    isAttachmentsEnabled: isAttachmentsEnabledSelector(state),
    isRequestDetailsEditMode: isRequestDetailsEditModeSelector(state),
    // leave this as pristineSelector instead of requestSelector as we'll need it to create dirtyRequest and there will be a race condition if we check for tabView changes
    pristineRequest: pristineRequestSelector(state),
    request: requestSelector(state),
    notes: notesSelector(state),
    errorList: errorListSelector(state),
    showError: showErrorSelector(state),
    showRequestSubNav: state.ContactState.RequestHistoryState.showRequestSubNav,
    isUnifiedPremier: isUnifiedPremierSelector(state),
    isUnifiedEnterprisePremier: isUnifiedEnterprisePremierSelector(state),
    isNonUnifiedPremier: isNonUnifiedPremierSelector(state),
    businessImpactConfirmed: businessImpactConfirmedSelector(state),
    customerAvailabilityConfirmed: customerAvailabilityConfirmedSelector(state),
    severity: severitySelector(state),
    isPremierTenantEnabled: isPremierTenantEnabledSelector(state),
  };
};

const mapDispatchToProps = {
  setDirtyRequest,
  resetRequestDetailsEditError,
};

export const RequestDetailsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(RequestDetails, getRequestDetailsStyles));
